/**
 * Assignment sheets — live "Total price to buyer".
 *
 * Total price is derived (contract price + assignment fee), never typed, so the sheet
 * shows it as a static line. The server renders it correct on open; this keeps it in
 * step while the fee is being typed. Delegated on `document` so it survives the HTMX
 * sheet swap. Server side: `acqs.services.assignments.compute_total_price`.
 */
(function () {
    function formatMoney(amount) {
        return '$' + amount.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }

    document.addEventListener('input', function (e) {
        var feeInput = e.target && e.target.closest ? e.target.closest('[data-assignment-fee]') : null;
        if (!feeInput) return;
        var block = feeInput.closest('[data-contract-price]');
        if (!block) return;
        var total = block.querySelector('[data-assignment-total]');
        if (!total) return;
        var contract = parseFloat(block.getAttribute('data-contract-price'));
        if (isNaN(contract)) contract = 0;
        var fee = parseFloat(feeInput.value);
        if (isNaN(fee)) fee = 0;
        total.textContent = formatMoney(contract + fee);
    });
})();
